/**
 * `@evolveos/focus-core` — all work-focus domain logic, with no runtime dependencies.
 *
 * Everything that decides what a number *means* lives here: the policy schema, the pose
 * geometry, the attention state machine, the event bands, the calibration maths and the
 * privacy rules. Hosts (an Electron agent, a browser pilot, the backend, the dashboard)
 * supply cameras, canvases, files and screens — never judgements.
 *
 * That split is the reason the reliability-critical behaviour is testable: the entire
 * decision path runs under plain Node with a `ManualClock`, so "a 31-second look away becomes
 * one potentially-significant event" is an assertion rather than an aspiration.
 */

export * from './models.js';
export * from './clock.js';
export * from './errors.js';
export * from './config.js';

export * from './vision/geometry.js';
export * from './vision/solvePnP.js';
export * from './vision/headPose.js';
export * from './vision/smoothing.js';
export * from './vision/similarityTransform.js';
export * from './vision/quality.js';

export * from './attention/classifier.js';
export * from './attention/stateEngine.js';
export * from './attention/events.js';
export * from './attention/stats.js';

export * from './calibration/profile.js';
export * from './calibration/session.js';

export * from './privacy/manifest.js';
export * from './privacy/consent.js';

export * from './session/sessionGuard.js';
export * from './session/faceTemplate.js';
export * from './enrolment/livenessChallenge.js';

export * from './pipeline.js';

/** Package version, stamped onto events as `agentVersion` by hosts that do not override it. */
export const CORE_VERSION = '0.2.0';
